import { useClassicAreaLink as useSharedClassicAreaLink } from '@onesource/components';
import { WP_MEMBERS_SITE } from 'src/config';

export const useClassicAreaLink = (self = false) => useSharedClassicAreaLink({ wpMembersSite: WP_MEMBERS_SITE, self });
